import type { ColumnsType } from "antd/es/table";

export const generateTableColumns = (props: any): ColumnsType => {

    return [
        {
            title: '标题',
            dataIndex: "Title",
        },
        {
            title: '分类id',
            dataIndex: "CateId",
        },
        {
            title: '上级id',
            dataIndex: "Pid",
        },
        {
            title: '路由',
            dataIndex: "Url",
        },
        {
            title: '方法',
            dataIndex: "Method",
        },
        // {
        //     title: '排序',
        //     dataIndex: "Sort",
        // },
        // {
        //     title: langTableColumns?.CreatedAtString,
        //     dataIndex: "CreatedAt",
        //     render: (val) => {
        //         return val ? dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss') : '-'
        //     }
        // },
    ]
}

